// @flow

import _ from 'lodash';
import React, { Component } from 'react';

const waitTimes = [3000, 7000];

type PhraseSpinnerProps = {
  phrases?: Array<string>,
  phrase?: string,
};

type PhraseSpinnerState = {
  phrases: Array<string>,
  phraseIndex: number,
  rotateCount: number,
  waitTimeIndex: number,
};

class PhraseSpinner extends Component<PhraseSpinnerProps, PhraseSpinnerState> {
  slowTimer: TimeoutID;
  rotateTimer: IntervalID;

  constructor(props: PhraseSpinnerProps) {
    super(props);
    this.state = {
      phrases: this.phrases(),
      phraseIndex: 0,
      rotateCount: 0,
      waitTimeIndex: 0,
    };
  }

  phrases = (): Array<string> => {
    if (this.props.phrases && this.props.phrases.length > 0) {
      return this.props.phrases;
    }
    if (typeof this.props.phrase === 'string') {
      return [this.props.phrase];
    }
    return ['Loading', 'Still loading', 'Still still loading'];
  };

  rotate = () => {
    this.setState({
      rotateCount: this.state.rotateCount + 1,
    });
  };

  sayNextPhrase = () => {
    if (this.state.phrases[this.state.phraseIndex + 1]) {
      this.setState({
        phraseIndex: this.state.phraseIndex + 1,
      });
      this.setupNextSlowTimer();
    }
  };

  setupNextSlowTimer = () => {
    this.slowTimer = setTimeout(
      this.sayNextPhrase,
      waitTimes[this.state.waitTimeIndex]
    );
    if (waitTimes[this.state.waitTimeIndex + 1]) {
      this.setState({
        waitTimeIndex: this.state.waitTimeIndex + 1,
      });
    }
  };

  componentDidMount() {
    this.rotateTimer = setInterval(this.rotate, 500);
    this.setupNextSlowTimer();
  }

  componentWillUnmount() {
    clearInterval(this.rotateTimer);
    clearTimeout(this.slowTimer);
  }

  ellipsis() {
    return (
      <span>
        {_.map(_.range(this.state.rotateCount % 4), () => '.').join('')}
        <span style={{ visibility: 'hidden' }}>
          {_.map(_.range(3 - (this.state.rotateCount % 4)), () => '.').join('')}
        </span>
      </span>
    );
  }

  currentPhrase = () => {
    const phrase = this.state.phrases[this.state.phraseIndex];
    if (typeof phrase === 'function') {
      return phrase(this.props);
    }
    return phrase;
  };

  render() {
    return (
      <span>
        {this.currentPhrase()}
        {this.ellipsis()}
      </span>
    );
  }
}

export default PhraseSpinner;
